import { colors } from "assets";

export default {
  informations: {
    display: "inline-flex"
  },
  checkBox: {
    paddingLeft: "4px"
  },
  tooltip: {
    padding: "10px 0px 0px 6px"
  },
  icon: {
    color: colors.primary.dark
  }
};



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/styles.js